//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mfg.AM.js";
import "../Mfg/Mfg.AM.Library.js";
let d=[[[0,"Active",1,"Mfg.AM.SupportProfile",0]],[[["pChildProfileLib"],"DeleteLibraryFolder",{},1,1],[["pChildProfile"],"DeleteProfile",{},1,1],[[],"AddSupportProfile",{R_:{newProfile:"Mfg.AM.SupportProfile"}},0,0],[["num_profiles"],"GetSupportProfiles",{R_:{profiles:"Mfg.AM.SupportProfile[]"}},0,0],[["profile"],"Remove",{},1,0],[["journal_identifier"],"FindObject",{R_:{found:"INXObject"}},1,0]],[]];
SPLM.Mfg.AM.ProfileLibrary = class extends SPLM.Mfg.AM.Library{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mfg.AM.ProfileLibrary";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;